export enum ReceiptTemplateType {
  TemplateId = 'TEMPLATE_ID',
}